import React from 'react';

export const KaabaIcon = ({ size = 24, className = '', primaryColor = 'currentColor', goldColor = '#c8960a' }) => (
  <svg width={size} height={size} viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
    <ellipse cx="28" cy="53" rx="17" ry="2.5" fill="black" opacity="0.1" />
    <polygon points="7,19 24,13 48,13 31,19" fill={primaryColor} opacity="0.55" />
    <polygon points="7,19 24,13 24,46 7,52" fill={primaryColor} opacity="0.65" />
    <rect x="24" y="13" width="24" height="33" fill={primaryColor} opacity="0.95" />
    <line x1="7" y1="19" x2="7" y2="52" stroke="white" strokeWidth="0.6" opacity="0.12" />
    <rect x="24" y="17.5" width="24" height="6" fill={goldColor} opacity="0.92" />
    <polygon points="7,21.5 24,17.5 24,23.5 7,27.5" fill={goldColor} opacity="0.78" />
    <circle cx="28.5" cy="20.5" r="0.9" fill="white" opacity="0.55" />
    <circle cx="32.5" cy="20.5" r="0.9" fill="white" opacity="0.55" />
    <circle cx="36.5" cy="20.5" r="0.9" fill="white" opacity="0.55" />
    <circle cx="40.5" cy="20.5" r="0.9" fill="white" opacity="0.55" />
    <circle cx="44.5" cy="20.5" r="0.9" fill="white" opacity="0.55" />
    <line x1="25" y1="18.5" x2="47" y2="18.5" stroke="white" strokeWidth="0.5" opacity="0.4" />
    <line x1="25" y1="22.5" x2="47" y2="22.5" stroke="white" strokeWidth="0.5" opacity="0.4" />
    <rect x="31.5" y="28" width="13" height="18" rx="0.5" fill={goldColor} opacity="0.9" />
    <path d="M33 46 L33 35 Q33 30 38 30 Q43 30 43 35 L43 46 Z" fill={primaryColor} opacity="0.9" />
    <path d="M34.5 39 Q38 31.5 41.5 39" fill="none" stroke={goldColor} strokeWidth="0.7" opacity="0.6" />
    <circle cx="38" cy="40" r="1.5" fill={goldColor} opacity="0.95" />
    <circle cx="38" cy="40" r="0.7" fill={primaryColor} opacity="0.7" />
    <rect x="30.5" y="45.5" width="15" height="2" rx="0.8" fill={goldColor} opacity="0.85" />
    <circle cx="38" cy="11" r="1.8" fill={goldColor} opacity="0.7" />
    <path d="M37 11 Q38 8.5 40 10 Q38 9.5 37 11Z" fill={primaryColor} opacity="0.6" />
  </svg>
);

export const MosqueIcon = ({ size = 24, className = '', color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
    <path d="M16 4C12 4 9 7.5 9 11h14C23 7.5 20 4 16 4Z" fill={color} opacity="0.9" />
    <rect x="9" y="11" width="14" height="3" rx="1" fill={color} opacity="0.85" />
    <rect x="4" y="12" width="4" height="12" rx="1" fill={color} opacity="0.8" />
    <path d="M6 8L4 12h4L6 8Z" fill={color} opacity="0.9" />
    <rect x="5.5" y="6" width="1" height="2.5" fill={color} opacity="0.9" />
    <rect x="24" y="12" width="4" height="12" rx="1" fill={color} opacity="0.8" />
    <path d="M26 8l-2 4h4l-2-4Z" fill={color} opacity="0.9" />
    <rect x="25.5" y="6" width="1" height="2.5" fill={color} opacity="0.9" />
    <rect x="7" y="14" width="18" height="10" rx="1.5" fill={color} opacity="0.75" />
    <path d="M13 24v-5a3 3 0 016 0v5" fill="none" stroke="white" strokeWidth="1.2" opacity="0.6" />
    <circle cx="11" cy="18" r="1.2" fill="white" opacity="0.5" />
    <circle cx="21" cy="18" r="1.2" fill="white" opacity="0.5" />
    <rect x="2" y="24" width="28" height="1.5" rx="0.75" fill={color} opacity="0.6" />
  </svg>
);

export const CrescentStarIcon = ({ size = 20, className = '', color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
    <path d="M12 3C8.13 3 5 6.13 5 10c0 3.87 3.13 7 7 7 1.27 0 2.46-.34 3.48-.94A8 8 0 0112 3z" fill={color} />
    <path d="M17 2l.5 1.5L19 4l-1.5.5L17 6l-.5-1.5L15 4l1.5-.5L17 2z" fill={color} />
  </svg>
);

export const StarOrnament = ({ size = 16, className = '', color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
    <path d="M8 0l1.5 3.5L13 2l-1.5 3.5L15 8l-3.5 1.5L13 13l-3.5-1.5L8 15l-1.5-3.5L3 13l1.5-3.5L1 8l3.5-1.5L3 3l3.5 1.5L8 0z" fill={color} opacity="0.7" />
  </svg>
);

/** Ramadan lantern — فانوس */
export const RamadanLanternIcon = ({ size = 24, className = '', color = 'currentColor' }) => (
  <svg width={size} height={size * 1.4} viewBox="0 0 28 40" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
    <line x1="14" y1="0" x2="14" y2="5" stroke={color} strokeWidth="1.5" strokeLinecap="round" />
    <line x1="10" y1="5" x2="18" y2="5" stroke={color} strokeWidth="1.5" strokeLinecap="round" />
    <path d="M9 5 Q14 3 19 5 L20 9 Q14 11.5 8 9 Z" fill={color} opacity="0.85" />
    <path d="M8 9 Q6.5 14 6 17 Q14 19 22 17 Q21.5 14 20 9 Q14 11.5 8 9 Z" fill={color} opacity="0.22" stroke={color} strokeWidth="0.7" />
    <rect x="6" y="17" width="16" height="2.5" rx="1" fill={color} opacity="0.8" />
    <circle cx="14" cy="18.25" r="1.2" fill={color} opacity="0.5" />
    <path d="M6 19.5 Q6.5 24 8 27 Q14 29 20 27 Q21.5 24 22 19.5 Q14 21.5 6 19.5 Z" fill={color} opacity="0.18" stroke={color} strokeWidth="0.7" />
    <ellipse cx="14" cy="22" rx="4.5" ry="3.5" fill={color} opacity="0.1" />
    <path d="M8 27 Q14 29 20 27 L20 30 Q14 32 8 30 Z" fill={color} opacity="0.85" />
    <line x1="14" y1="30" x2="14" y2="36" stroke={color} strokeWidth="1" strokeLinecap="round" />
    <circle cx="14" cy="37.5" r="2" fill={color} opacity="0.8" />
    <line x1="10" y1="30" x2="8" y2="36" stroke={color} strokeWidth="0.7" strokeLinecap="round" opacity="0.5" />
    <circle cx="8" cy="37" r="1.2" fill={color} opacity="0.5" />
    <line x1="18" y1="30" x2="20" y2="36" stroke={color} strokeWidth="0.7" strokeLinecap="round" opacity="0.5" />
    <circle cx="20" cy="37" r="1.2" fill={color} opacity="0.5" />
  </svg>
);

/** Prayer beads — مسبحة */
export const TasbihIcon = ({ size = 24, className = '', color = 'currentColor' }) => {
  const beads = [0,30,60,90,120,150,180,210,240,270,300,330];
  return (
    <svg width={size} height={size} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <circle cx="16" cy="16" r="9" fill="none" stroke={color} strokeWidth="0.8" opacity="0.4" />
      {beads.map((deg, i) => {
        const rad = (deg * Math.PI) / 180;
        const cx = 16 + 9 * Math.sin(rad);
        const cy = 16 - 9 * Math.cos(rad);
        return <circle key={i} cx={cx} cy={cy} r={i % 3 === 0 ? 1.8 : 1.3} fill={color} opacity={i % 3 === 0 ? 0.85 : 0.65} />;
      })}
      <line x1="16" y1="4" x2="16" y2="1" stroke={color} strokeWidth="1" strokeLinecap="round" opacity="0.7" />
      <ellipse cx="16" cy="0.5" rx="1.5" ry="1" fill={color} opacity="0.7" />
    </svg>
  );
};

/** Prayer mat — سجادة */
export const PrayerMatIcon = ({ size = 24, className = '', color = 'currentColor' }) => (
  <svg width={size} height={size * 0.75} viewBox="0 0 32 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
    <rect x="1" y="2" width="30" height="20" rx="2" fill={color} opacity="0.15" stroke={color} strokeWidth="1" />
    <path d="M10 10 Q16 4 22 10 L22 18 L10 18 Z" fill={color} opacity="0.25" stroke={color} strokeWidth="0.8" />
    <circle cx="16" cy="5.5" r="1.5" fill={color} opacity="0.6" />
    <line x1="1" y1="5" x2="31" y2="5" stroke={color} strokeWidth="0.6" opacity="0.4" />
    <line x1="1" y1="19" x2="31" y2="19" stroke={color} strokeWidth="0.6" opacity="0.4" />
    {[3,5,7,9,11,13,19,21,23,25,27,29].map(x => (
      <line key={x} x1={x} y1="21" x2={x} y2="23" stroke={color} strokeWidth="0.6" opacity="0.4" strokeLinecap="round" />
    ))}
  </svg>
);

export const IslamicDivider = ({ isDarkMode, className = '' }) => {
  const c = isDarkMode ? 'rgba(251,191,36,0.25)' : 'rgba(0,0,0,0.12)';
  return (
    <div className={`flex items-center gap-2 py-1 ${className}`}>
      <svg className="flex-1 h-3" viewBox="0 0 120 12" preserveAspectRatio="none" fill="none">
        <path d="M120 6 Q100 2 80 6 Q60 10 40 6 Q20 2 0 6" stroke={c} strokeWidth="1" />
        <circle cx="20" cy="6" r="1.5" fill={c} /><circle cx="60" cy="6" r="1.5" fill={c} /><circle cx="100" cy="6" r="1.5" fill={c} />
      </svg>
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" className="flex-shrink-0">
        <path d="M8 0l1.5 3.5L13 2l-1.5 3.5L15 8l-3.5 1.5L13 13l-3.5-1.5L8 15l-1.5-3.5L3 13l1.5-3.5L1 8l3.5-1.5L3 3l3.5 1.5L8 0z" fill={c} />
        <circle cx="8" cy="8" r="2.5" fill={isDarkMode ? 'rgba(251,191,36,0.4)' : 'rgba(0,0,0,0.18)'} />
      </svg>
      <svg className="flex-1 h-3" viewBox="0 0 120 12" preserveAspectRatio="none" fill="none">
        <path d="M0 6 Q20 2 40 6 Q60 10 80 6 Q100 2 120 6" stroke={c} strokeWidth="1" />
        <circle cx="20" cy="6" r="1.5" fill={c} /><circle cx="60" cy="6" r="1.5" fill={c} /><circle cx="100" cy="6" r="1.5" fill={c} />
      </svg>
    </div>
  );
};

export const IslamicCorners = ({ isDarkMode, opacity = 0.12 }) => {
  const c = isDarkMode ? `rgba(251,191,36,${opacity})` : `rgba(0,0,0,${opacity})`;
  const Star = () => (
    <svg width="18" height="18" viewBox="0 0 16 16" fill="none">
      <path d="M8 0l1.5 3.5L13 2l-1.5 3.5L15 8l-3.5 1.5L13 13l-3.5-1.5L8 15l-1.5-3.5L3 13l1.5-3.5L1 8l3.5-1.5L3 3l3.5 1.5L8 0z" fill={c} />
    </svg>
  );
  return (
    <>
      <div className="absolute top-2 left-2 pointer-events-none"><Star /></div>
      <div className="absolute top-2 right-2 pointer-events-none"><Star /></div>
      <div className="absolute bottom-2 left-2 pointer-events-none"><Star /></div>
      <div className="absolute bottom-2 right-2 pointer-events-none"><Star /></div>
    </>
  );
};

export const GeometricPatternBg = ({ isDarkMode, opacity = 0.04 }) => (
  <svg className="absolute inset-0 w-full h-full pointer-events-none" xmlns="http://www.w3.org/2000/svg" style={{ zIndex: 0, opacity }}>
    <defs>
      <pattern id="geo8" x="0" y="0" width="36" height="36" patternUnits="userSpaceOnUse">
        <path d="M18 4l2 6 6 2-6 2-2 6-2-6-6-2 6-2z" fill={isDarkMode ? 'white' : 'black'} />
        <path d="M0 0l1 3 3 1-3 1-1 3-1-3-3-1 3-1z" fill={isDarkMode ? 'white' : 'black'} opacity="0.6" />
        <path d="M36 36l1 3 3 1-3 1-1 3-1-3-3-1 3-1z" fill={isDarkMode ? 'white' : 'black'} opacity="0.6" />
        <line x1="0" y1="18" x2="36" y2="18" stroke={isDarkMode ? 'white' : 'black'} strokeWidth="0.3" opacity="0.3" />
        <line x1="18" y1="0" x2="18" y2="36" stroke={isDarkMode ? 'white' : 'black'} strokeWidth="0.3" opacity="0.3" />
      </pattern>
    </defs>
    <rect width="100%" height="100%" fill="url(#geo8)" />
  </svg>
);

/** Open Quran book icon */
export const QuranBookIcon = ({ size = 24, className = '', color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 32 28" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
    {/* Left page */}
    <path d="M2 3.5 Q3 1 5 1.5 Q9 2.5 14 3.5 L14 25.5 Q9 24 5 25 Q3 25.5 2 24 Z"
      fill={color} opacity="0.12" stroke={color} strokeWidth="1.1" strokeLinejoin="round"/>
    {/* Right page */}
    <path d="M18 3.5 Q23 2.5 27 1.5 Q29 1 30 3.5 L30 24 Q29 25.5 27 25 Q23 24 18 25.5 Z"
      fill={color} opacity="0.12" stroke={color} strokeWidth="1.1" strokeLinejoin="round"/>
    {/* Spine binding */}
    <line x1="16" y1="1.5" x2="16" y2="26.5" stroke={color} strokeWidth="1.8" strokeLinecap="round"/>
    {/* Top curve — binding cap */}
    <path d="M14 1.5 Q16 0 18 1.5" stroke={color} strokeWidth="1.2" fill="none" strokeLinecap="round"/>
    <path d="M14 26.5 Q16 28 18 26.5" stroke={color} strokeWidth="1.2" fill="none" strokeLinecap="round"/>
    {/* Text lines — left page */}
    <line x1="5"  y1="8"    x2="13" y2="7.5"  stroke={color} strokeWidth="0.9" strokeLinecap="round" opacity="0.65"/>
    <line x1="5"  y1="11.5" x2="13" y2="11"   stroke={color} strokeWidth="0.9" strokeLinecap="round" opacity="0.65"/>
    <line x1="5"  y1="15"   x2="13" y2="14.5" stroke={color} strokeWidth="0.9" strokeLinecap="round" opacity="0.65"/>
    <line x1="5"  y1="18.5" x2="11" y2="18.2" stroke={color} strokeWidth="0.9" strokeLinecap="round" opacity="0.45"/>
    {/* Text lines — right page */}
    <line x1="19" y1="8"    x2="27" y2="7.5"  stroke={color} strokeWidth="0.9" strokeLinecap="round" opacity="0.65"/>
    <line x1="19" y1="11.5" x2="27" y2="11"   stroke={color} strokeWidth="0.9" strokeLinecap="round" opacity="0.65"/>
    <line x1="19" y1="15"   x2="27" y2="14.5" stroke={color} strokeWidth="0.9" strokeLinecap="round" opacity="0.65"/>
    <line x1="19" y1="18.5" x2="25" y2="18.2" stroke={color} strokeWidth="0.9" strokeLinecap="round" opacity="0.45"/>
  </svg>
);

export const SectionDivider = IslamicDivider;
export const IslamicBorderFrame = ({ isDarkMode, children, className = '' }) => (
  <div className={`relative ${className}`}>
    <IslamicCorners isDarkMode={isDarkMode} opacity={isDarkMode ? 0.18 : 0.1} />
    {children}
  </div>
);
export const HalfMoonAccent = ({ isDarkMode, size = 32 }) => (
  <svg width={size} height={size / 2} viewBox="0 0 32 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M0 16 Q16 -4 32 16" stroke={isDarkMode ? 'rgba(251,191,36,0.3)' : 'rgba(0,0,0,0.1)'} strokeWidth="1.5" fill="none" />
    <circle cx="16" cy="2" r="2" fill={isDarkMode ? 'rgba(251,191,36,0.35)' : 'rgba(0,0,0,0.12)'} />
  </svg>
);
